var map = {
	"./bg185.png": 21173,
	"./br/PT/S1/bg185.png": 69669,
	"./in/EN/S1/bg185.png": 64849,
	"./ph/EN/S1/bg185.png": 83309,
	"./vn/VI/S1/bg185.png": 15834
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85103;